// ワークフローのステージ判定（純関数）。useLocation().pathname から現ステージを決める。
// 線形 4 ステージだが、ステージ1（計算セット準備）は new-project / existing-project の 2 入口を持つ。
// 表示と遷移のみで、既存の操作可否ガードは変えない（A2: カテゴリ b）。

export type WorkflowTool = 'r' | 'l';

export interface WorkflowStageInfo {
    tool: WorkflowTool;
    stageIndex: number; // 0..3
}

export const WORKFLOW_STAGES = [
    { key: 'prepare', label: '計算セット準備' },
    { key: 'data', label: 'データ登録' },
    { key: 'calc', label: '計算' },
    { key: 'result', label: '結果' },
] as const;

// 各サブパス → ステージ index。'' は tool 直下（index は new-project へ redirect されるため準備扱い）。
const STAGE_BY_SUB: Record<string, number> = {
    '': 0,
    'new-project': 0,
    'existing-project': 0,
    'data-registration': 1,
    calculation: 2,
    'cabin-noise': 3, // R 結果
    'mtg-vib': 3, // R 結果
    matrix: 3, // L 結果
};

// ステージ → 代表 route（クリック遷移先）。
// ステージ1 のクリック先は existing-project（ステッパーから計算セット選択へ戻る主要導線）。
// 結果は R=cabin-noise / L=matrix を代表とする。
export const stageRoute = (tool: WorkflowTool, stageIndex: number): string => {
    const base = `/${tool}-tools`;
    switch (stageIndex) {
        case 0:
            return `${base}/existing-project`;
        case 1:
            return `${base}/data-registration`;
        case 2:
            return `${base}/calculation`;
        case 3:
            return tool === 'r' ? `${base}/cabin-noise` : `${base}/matrix`;
        default:
            return base;
    }
};

// pathname → 現ステージ。tool 外（NotFound 等）や未知サブパスは null（ステッパー非表示）。
export const stageFromPath = (pathname: string): WorkflowStageInfo | null => {
    const tool: WorkflowTool | null = pathname.startsWith('/r-tools')
        ? 'r'
        : pathname.startsWith('/l-tools')
            ? 'l'
            : null;
    if (!tool) return null;

    const sub = pathname.replace(/^\/[rl]-tools\/?/, '').replace(/\/$/, '');
    const stageIndex = STAGE_BY_SUB[sub];
    if (stageIndex === undefined) return null;
    return { tool, stageIndex };
};
